export default {
    Banners: 'ComponentRepeatableComponentsBanners',
    Category: 'ComponentRepeatableComponentsCategory',
    Gallery: 'ComponentRepeatableComponentsGallery',
    Button: 'ComponentRepeatableComponentsButton',
    ButtonGroup: 'ComponentRepeatableComponentsButtonGroup',
    HtmlText: 'ComponentRepeatableComponentsHtmlText',
    HidingItems: 'ComponentRepeatableComponentsHidingItems',
    ImagePlusText: 'ComponentRepeatableComponentsImagePlusText',
    LatestArrivals: 'ComponentRepeatableComponentsLatestArrivals',
    Offers: 'ComponentRepeatableComponentsOffers',
    ProductCard: 'ComponentRepeatableComponentsProductCard',
    ProductGallery: 'ComponentRepeatableComponentsProductGallery',
    PromoImages: 'ComponentRepeatableComponentsPromoImages',
    RandomButtonPicker: 'ComponentRepeatableComponentsRandomButtonPicker',
    TopBlogPosts: 'ComponentRepeatableComponentsTopBlogPosts',
    TopBrands: 'ComponentRepeatableComponentsTopBrands',
    Video: 'ComponentRepeatableComponentsVideo',
    VideoEmbed: 'ComponentRepeatableComponentsVideoEmbed',
    VideoVimeo: 'ComponentRepeatableComponentsVideoVimeo',
};
